var _excluded = ["header", "icon", "description", "primaryButton", "secondaryButton", "children", "footer", "illustration", "shouldHideCloseButton", "aria-label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Box } from '../../../components/internal';
import { ConditionalWrapper } from '../../../components/internal/ConditionalWrapper';
import { useBreakpoint, useBreakpointValue } from '../../../theme';
import { themeSpaces } from '../../../theme/foundations';
import { forwardRef } from '../../../utils';
import { BaseModal } from '../BaseModal';
import { ModalFooter, ModalHeader } from './componentes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Modal = forwardRef((_ref, ref) => {
  var {
    header,
    icon,
    description,
    primaryButton,
    secondaryButton,
    children,
    footer,
    illustration,
    shouldHideCloseButton,
    'aria-label': ariaLabel = header
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    isExtraSmallScreen: isMobile
  } = useBreakpoint();
  var showHeader = !!illustration || !!icon || !!header || !!description;
  var bodyElementPaddingTop = useBreakpointValue({
    xs: shouldHideCloseButton ? 'm' : "calc(".concat(themeSpaces.m, " + ").concat(themeSpaces.m, ")"),
    s: shouldHideCloseButton ? 'xxl' : "calc(".concat(themeSpaces.xxl, " + ").concat(themeSpaces.xs, ")")
  });
  return /*#__PURE__*/_jsxs(BaseModal, _objectSpread(_objectSpread({
    "data-component": "Modal"
  }, props), {}, {
    shouldHideCloseButton: shouldHideCloseButton,
    "aria-label": ariaLabel,
    ref: ref,
    children: [showHeader && /*#__PURE__*/_jsx(ModalHeader, {
      illustration: illustration,
      icon: !isMobile ? icon : undefined,
      description: description,
      children: header
    }), /*#__PURE__*/_jsx(BaseModal.Body, {
      children: /*#__PURE__*/_jsx(ConditionalWrapper, {
        condition: !showHeader,
        wrapper: children => /*#__PURE__*/_jsx(Box, {
          paddingTop: bodyElementPaddingTop,
          children: children
        }),
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: children
        })
      })
    }), /*#__PURE__*/_jsx(ModalFooter, {
      primaryButton: primaryButton,
      secondaryButton: secondaryButton,
      children: footer
    })]
  }));
});
Modal.displayName = 'Modal';
//# sourceMappingURL=Modal.js.map